import Vue from 'vue';
import VueResize from 'vue-resize';
import VueI18n from 'vue-i18n';
import VueParticles from 'vue-particles';
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import NProgress from 'nprogress';
import '@/styles/nprogress.less';
import VueCropper from 'vue-cropper';

import App from './App.vue';
import store from './store';
import router from './router';
import moment from 'moment';

import 'vue-resize/dist/vue-resize.css';

import 'font-awesome/css/font-awesome.css';
import 'flag-icon-css/css/flag-icon.min.css';
import { _queryAllDictionaries } from './api/sysDictionaryApi';
import { _queryLocation } from './api/locationApi';

import '../public/main.css';

NProgress.configure({ showSpinner: false });

Vue.config.productionTip = false;

Vue.use(VueParticles);

Vue.use(VueResize);

Vue.use(VueI18n);

Vue.use(VueCropper);

Vue.config.productionTip = false

Vue.use(moment);

Vue.use(Antd, { size: 'small' });

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      NProgress.done(); // start progress bar
    } else {
      next();
      NProgress.done(); // start progress bar
    }
  } else {
    next(); // 确保一定要调用 next()
    NProgress.done(); // start progress bar
  }
});

Vue.directive('has', {
  // 定义是否含有该按钮权限
  inserted(el, binding) {
    function permissionJudge(value) {
      const set = new Set(JSON.parse(localStorage.getItem('BUTTONS')));
      return set.has(value);
    }

    if (!permissionJudge(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});

// 注册 (指令函数)
Vue.directive('dict', {
  inserted(el, binding) {
    const { parentNode } = el;
    parentNode.removeChild(el);
    parentNode.append(store.getters.getDictionaryDataByKey(binding.value).name);
  },
});

Vue.prototype.$dict = (code, value) => {
  const key = `${code}-${value}`;
  return store.getters.getDictionaryDataByKey(key) ? store.getters.getDictionaryDataByKey(key).name : '';
};

const locate = localStorage.getItem('language') || 'zh-CN';

const messages = {
  en: {
    LOGIN_NAME: 'Login name',
    PASSWORD: 'Password',
    LOGIN: 'Login',
  },
  'zh-CN': {
    LOGIN_NAME: '账号',
    PASSWORD: '密码',
    LOGIN: '登录',
  },
};

let i18n = new VueI18n({
  locale: locate, // set locale
  messages, // set locale messages
});

Promise.all([_queryAllDictionaries(), _queryLocation()])
  .then(([result, locationResult]) => {
    result.forEach((x) => {
      store.commit('addDictionary', {
        key: x.code,
        value: x,
      });
      x.data.forEach((d) => {
        store.commit('addDictionaryData', {
          key: `${x.code}-${d.code}`,
          value: d,
        });
      });
    });
    const { languages, i18NDetails } = locationResult;
    languages.forEach((x) => {
      store.commit('addLanguage', x);
    });
    i18NDetails.forEach((x) => {
      if (messages[x.languageCode]) {
        messages[x.languageCode][x.i18nCode] = x.value;
      }
    });
    i18n = new VueI18n({
      locale: locate, // set locale
      messages, // set locale messages
    });
    new Vue({
      store,
      router,
      i18n,
      render: h => h(App),
    }).$mount('#app');
  });
